import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  VARIABLE_TEXT_FEATURE_FLAG_ALL,
  VariableSelectFeatureFlag,
  VariableTextFeatureFlag,
} from '@makyoapp/makyo-common'

import { BuilderComponentGroup, BuilderComponentSettingType, ComponentSettingKey, SpacingInputUnit } from '../types'
import { LABELS } from '../types/labels'
import { makeClampWidthItems, makeTextColorSettings, makeTypographyGroup } from '../utils/components'

export const ProgressComponents: BuilderComponentGroup = {
  id: 'progress',
  title: 'Progress Indicators',
  components: [
    {
      compId: 'linear-progress',
      title: LABELS.LINEAR_PROGRESS_KEY,
      searchKeywords: ['progress bar', 'loading bar', 'status bar', 'indicator', 'completion bar'],
      icon: 'Progress24',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        dataGroup: {
          [LABELS.DATA_SOURCE_KEY]: {
            items: [
              {
                id: ComponentSettingKey.LinearProgressDataValue,
                type: BuilderComponentSettingType.VariableSelect,
                label: LABELS.CURRENT_VALUE_KEY,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.CustomText,
                  value: '25',
                },
                variableSelectSettings: {
                  flags:
                    VariableSelectFeatureFlag.CurrentRow |
                    VariableSelectFeatureFlag.SingleCell |
                    VariableSelectFeatureFlag.CustomText,
                  columnTypes: [ColumnTypes.Number],
                  inputType: 'number',
                },
              },
              {
                id: ComponentSettingKey.LinearProgressDataMaxValue,
                type: BuilderComponentSettingType.VariableSelect,
                label: LABELS.MAX_VALUE_KEY,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.CustomText,
                  value: '100',
                },
                variableSelectSettings: {
                  flags:
                    VariableSelectFeatureFlag.CurrentRow |
                    VariableSelectFeatureFlag.SingleCell |
                    VariableSelectFeatureFlag.CustomText,
                  columnTypes: [ColumnTypes.Number],
                  inputType: 'number',
                },
              },
            ],
          },
          [LABELS.COMPONENT_TITLE_KEY]: {
            items: [
              {
                id: ComponentSettingKey.LinearProgressDataTitle,
                type: BuilderComponentSettingType.VariableText,
                label: LABELS.COMPONENT_TITLE_KEY,
                defaultValue: [
                  {
                    type: 'paragraph',
                    children: [{ text: 'Progress' }],
                  },
                ],
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_ALL & ~VariableTextFeatureFlag.ColumnData,
                },
              },
            ],
          },
        },
        designGroup: {
          // [LABELS.COLOR_SCHEME_KEY]: {
          //   items: [
          //     makeScheme(ComponentSettingKey.LinearProgressDesignScheme, true),
          //     {
          //       id: ComponentSettingKey.LinearProgressDesignCompTitleColor,
          //       label: LABELS.COMPONENT_TITLE_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'on-surface',
          //       colorVariantSettings: {
          //         schemeId: ComponentSettingKey.LinearProgressDesignScheme,
          //         fullColor: 'fg',
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.LinearProgressDesignActiveIndicatorColor,
          //       label: LABELS.ACTIVE_INDICATOR_COLOR_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'primary',
          //       colorVariantSettings: {
          //         schemeId: ComponentSettingKey.LinearProgressDesignScheme,
          //         fullColor: 'bg',
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.LinearProgressDesignTrackColor,
          //       label: LABELS.TRACK_COLOR_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'secondary-container',
          //       colorVariantSettings: {
          //         schemeId: ComponentSettingKey.LinearProgressDesignScheme,
          //         fullColor: 'bg',
          //       },
          //     },
          //   ],
          // },
          [LABELS.TYPOGRAPHY_KEY]: makeTypographyGroup(ComponentSettingKey.LinearProgressDesignTypography, [
            {
              id: ComponentSettingKey.LinearProgressDesignHeadingTypography,
              label: LABELS.COMPONENT_TITLE_KEY,
              defaultValue: 'Title Large',
            },
            {
              id: ComponentSettingKey.LinearProgressDesignValueTypography,
              label: LABELS.VALUE_KEY,
              defaultValue: 'Body Small',
            },
          ]),
          [LABELS.DIMENSION_KEY]: {
            items: [
              ...makeClampWidthItems(ComponentSettingKey.LinearProgressDesignWidth).items,
              {
                id: ComponentSettingKey.LinearProgressDesignHeight,
                type: BuilderComponentSettingType.Slider,
                label: LABELS.HEIGHT_KEY,
                defaultValue: [10],
                sliderSettings: {
                  max: 20,
                  min: 4,
                  step: 1,
                  unit: 'px',
                },
              },
            ],
          },
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.LinearProgressDesignAlignment,
                type: BuilderComponentSettingType.ComponentAlignment,
                label: LABELS.COMPONENT_ALIGNMENT_KEY,
                defaultValue: 'parent',
              },
              // {
              //   id: ComponentSettingKey.LinearProgressDesignHeadingAlignment,
              //   type: BuilderComponentSettingType.HorizontalAlignment,
              //   label: LABELS.COMPONENT_TITLE_KEY,
              // },
              // {
              //   id: ComponentSettingKey.LinearProgressValueAlignment,
              //   type: BuilderComponentSettingType.HorizontalAlignment,
              //   label: LABELS.VALUE_KEY,
              //   defaultValue: 'end',
              // },
            ],
          },
          [LABELS.SPACING_KEY]: {
            items: [
              {
                id: ComponentSettingKey.LinearProgressDesignMargin,
                type: BuilderComponentSettingType.Spacing,
                label: LABELS.COMPONENT_MARGIN_KEY,
                defaultValue: {
                  top: {
                    value: 20,
                    unit: SpacingInputUnit.Pixel,
                  },
                  bottom: {
                    value: 10,
                    unit: SpacingInputUnit.Pixel,
                  },
                  left: {
                    value: 20,
                    unit: SpacingInputUnit.Pixel,
                  },
                  right: {
                    value: 20,
                    unit: SpacingInputUnit.Pixel,
                  },
                },
                // spacingSettings: {
                //   max: {
                //     [SpacingInputUnit.Em]: 4,
                //     [SpacingInputUnit.Rem]: 4,
                //     [SpacingInputUnit.Pixel]: Infinity,
                //     [SpacingInputUnit.Percent]: 10,
                //   },
                // },
              },
              {
                id: ComponentSettingKey.LinearProgressDesignTitleMargin,
                type: BuilderComponentSettingType.Spacing,
                label: LABELS.COMPONENT_TITLE_KEY,
                defaultValue: {
                  top: {
                    value: 20,
                    unit: SpacingInputUnit.Pixel,
                  },
                  bottom: {
                    value: 20,
                    unit: SpacingInputUnit.Pixel,
                  },
                  left: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  right: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                },
                // spacingSettings: {
                //   max: {
                //     [SpacingInputUnit.Em]: 4,
                //     [SpacingInputUnit.Rem]: 4,
                //     [SpacingInputUnit.Pixel]: Infinity,
                //     [SpacingInputUnit.Percent]: 10,
                //   },
                // },
              },
              {
                id: ComponentSettingKey.LinearProgressDesignValueMargin,
                type: BuilderComponentSettingType.Spacing,
                label: LABELS.VALUE_KEY,
                defaultValue: {
                  top: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  bottom: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  left: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  right: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                },
                // spacingSettings: {
                //   max: {
                //     [SpacingInputUnit.Em]: 4,
                //     [SpacingInputUnit.Rem]: 4,
                //     [SpacingInputUnit.Pixel]: Infinity,
                //     [SpacingInputUnit.Percent]: 10,
                //   },
                // },
              },
            ],
          },
          [LABELS.COLORS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.LinearProgressDesignGroupColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.LABEL_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.LinearProgressDesignLabelColor,
                      ComponentSettingKey.LinearProgressDesignLabelColorSolid,
                      ComponentSettingKey.LinearProgressDesignLabelColorStartGradient,
                      ComponentSettingKey.LinearProgressDesignLabelColorEndGradient,
                      ComponentSettingKey.LinearProgressDesignLabelColorGradientDirection,
                      ComponentSettingKey.LinearProgressDesignScheme,
                      LABELS.LABEL_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.VALUE_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.LinearProgressDesignValueColor,
                      ComponentSettingKey.LinearProgressDesignValueColorSolid,
                      ComponentSettingKey.LinearProgressDesignValueColorStartGradient,
                      ComponentSettingKey.LinearProgressDesignValueColorEndGradient,
                      ComponentSettingKey.LinearProgressDesignValueColorGradientDirection,
                      ComponentSettingKey.LinearProgressDesignScheme,
                      LABELS.VALUE_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.CIRCLE_INDICATOR_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.LinearProgressDesignCircleColor,
                      ComponentSettingKey.LinearProgressDesignCircleColorSolid,
                      ComponentSettingKey.LinearProgressDesignCircleColorStartGradient,
                      ComponentSettingKey.LinearProgressDesignCircleColorEndGradient,
                      ComponentSettingKey.LinearProgressDesignCircleColorGradientDirection,
                      ComponentSettingKey.LinearProgressDesignScheme,
                      LABELS.CIRCLE_INDICATOR_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.CIRCLE_TRACK_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.LinearProgressDesignTrackColor,
                      ComponentSettingKey.LinearProgressDesignTrackColorSolid,
                      ComponentSettingKey.LinearProgressDesignTrackColorStartGradient,
                      ComponentSettingKey.LinearProgressDesignTrackColorEndGradient,
                      ComponentSettingKey.LinearProgressDesignTrackColorGradientDirection,
                      ComponentSettingKey.LinearProgressDesignScheme,
                      LABELS.CIRCLE_TRACK_KEY,
                      'adaptive'
                    ).items,
                  ],
                },
              },
            ],
          },
        },
        behavior: {
          visibility: true,
        },
      },
    },
    {
      compId: 'circular-progress',
      title: LABELS.CIRCULAR_PROGRESS_KEY,
      searchKeywords: ['spinner', 'circular loader', 'progress circle', 'loading indicator', 'donut progress'],
      icon: 'CircularProgress24',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        dataGroup: {
          [LABELS.DATA_SOURCE_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDataValue,
                type: BuilderComponentSettingType.VariableSelect,
                label: LABELS.CURRENT_VALUE_KEY,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.CustomText,
                  value: '25',
                },
                variableSelectSettings: {
                  flags:
                    VariableSelectFeatureFlag.CurrentRow |
                    VariableSelectFeatureFlag.SingleCell |
                    VariableSelectFeatureFlag.CustomText,
                  columnTypes: [ColumnTypes.Number],
                  inputType: 'number',
                },
              },
              {
                id: ComponentSettingKey.CircularProgressDataMaxValue,
                type: BuilderComponentSettingType.VariableSelect,
                label: LABELS.MAX_VALUE_KEY,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.CustomText,
                  value: '100',
                },
                variableSelectSettings: {
                  flags:
                    VariableSelectFeatureFlag.CurrentRow |
                    VariableSelectFeatureFlag.SingleCell |
                    VariableSelectFeatureFlag.CustomText,
                  columnTypes: [ColumnTypes.Number],
                  inputType: 'number',
                },
              },
            ],
          },
          [LABELS.COMPONENT_TITLE_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDataHeading,
                type: BuilderComponentSettingType.VariableText,
                label: LABELS.COMPONENT_TITLE_KEY,
                defaultValue: [
                  {
                    type: 'paragraph',
                    children: [{ text: '' }],
                  },
                ],
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_ALL & ~VariableTextFeatureFlag.ColumnData,
                },
              },
            ],
          },
        },
        designGroup: {
          // [LABELS.COLOR_VARIANT_KEY]: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.CircularProgressDesignActiveIndicatorColor,
          //       label: LABELS.ACTIVE_INDICATOR_COLOR_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'primary-20',
          //       colorVariantSettings: {
          //         schemeId: ComponentSettingKey.CircularProgressDesignScheme,
          //         fullColor: 'bg',
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.CircularProgressDesignTrackColor,
          //       label: LABELS.TRACK_COLOR_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'primary-90',
          //       colorVariantSettings: {
          //         schemeId: ComponentSettingKey.CircularProgressDesignScheme,
          //         fullColor: 'bg',
          //       },
          //     },
          //   ],
          // },
          [LABELS.SHOW_VALUE_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDesignShowValue,
                type: BuilderComponentSettingType.Switch,
                defaultValue: true,
                label: LABELS.SHOW_VALUE_KEY,
              },
            ],
          },
          [LABELS.TYPOGRAPHY_KEY]: makeTypographyGroup(ComponentSettingKey.CircularProgressDesignTypography, [
            {
              id: ComponentSettingKey.CircularProgressDesignHeadingTypography,
              label: LABELS.COMPONENT_TITLE_KEY,
              defaultValue: 'Body Small',
            },
            {
              id: ComponentSettingKey.CircularProgressDesignLabelTypography,
              label: LABELS.LABEL_KEY,
              defaultValue: 'Body Large',
            },
          ]),
          [LABELS.DIMENSION_KEY]: makeClampWidthItems(ComponentSettingKey.CircularProgressDesignSize, {
            label: LABELS.SIZE_KEY,
            defaultValue: 48,
            defaultUnit: 'px',
          }),
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDesignAlignment,
                type: BuilderComponentSettingType.ComponentAlignment,
                label: LABELS.COMPONENT_KEY,
              },
              {
                id: ComponentSettingKey.CircularProgressDesignHeadingAlignment,
                type: BuilderComponentSettingType.HorizontalAlignment,
                label: LABELS.COMPONENT_TITLE_KEY,
              },
            ],
          },
          [LABELS.SPACING_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDesignMargin,
                type: BuilderComponentSettingType.Spacing,
                label: LABELS.COMPONENT_MARGIN_KEY,
                defaultValue: {
                  top: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  bottom: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  left: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  right: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                },
                // spacingSettings: {
                //   max: {
                //     [SpacingInputUnit.Em]: 4,
                //     [SpacingInputUnit.Rem]: 4,
                //     [SpacingInputUnit.Pixel]: Infinity,
                //     [SpacingInputUnit.Percent]: 10,
                //   },
                // },
              },
              {
                id: ComponentSettingKey.CircularProgressDesignHeadingMargin,
                type: BuilderComponentSettingType.Spacing,
                label: LABELS.COMPONENT_TITLE_MARGIN_KEY,
                defaultValue: {
                  top: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  bottom: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  left: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                  right: {
                    value: 0,
                    unit: SpacingInputUnit.Pixel,
                  },
                },
                // spacingSettings: {
                //   max: {
                //     [SpacingInputUnit.Em]: 4,
                //     [SpacingInputUnit.Rem]: 4,
                //     [SpacingInputUnit.Pixel]: Infinity,
                //     [SpacingInputUnit.Percent]: 10,
                //   },
                // },
              },
            ],
          },
          [LABELS.COLORS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.CircularProgressDesignGroupColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.LABEL_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.CircularProgressDesignLabelColor,
                      ComponentSettingKey.CircularProgressDesignLabelColorSolid,
                      ComponentSettingKey.CircularProgressDesignLabelColorStartGradient,
                      ComponentSettingKey.CircularProgressDesignLabelColorEndGradient,
                      ComponentSettingKey.CircularProgressDesignLabelColorGradientDirection,
                      ComponentSettingKey.CircularProgressDesignScheme,
                      'Label',
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.VALUE_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.CircularProgressDesignValueColor,
                      ComponentSettingKey.CircularProgressDesignValueColorSolid,
                      ComponentSettingKey.CircularProgressDesignValueColorStartGradient,
                      ComponentSettingKey.CircularProgressDesignValueColorEndGradient,
                      ComponentSettingKey.CircularProgressDesignValueColorGradientDirection,
                      ComponentSettingKey.CircularProgressDesignScheme,
                      'Value',
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.CIRCLE_INDICATOR_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.CircularProgressDesignCircleColor,
                      ComponentSettingKey.CircularProgressDesignCircleColorSolid,
                      ComponentSettingKey.CircularProgressDesignCircleColorStartGradient,
                      ComponentSettingKey.CircularProgressDesignCircleColorEndGradient,
                      ComponentSettingKey.CircularProgressDesignCircleColorGradientDirection,
                      ComponentSettingKey.CircularProgressDesignScheme,
                      'Circle',
                      'adaptive'
                    ).items,
                  ],
                },
              },
              {
                id: ComponentSettingKey.CircularProgressDesignTrackColor,
                label: LABELS.TRACK_COLOR_KEY,
                type: BuilderComponentSettingType.ColorVariant,
                defaultValue: 'primary-90',
                colorVariantSettings: {
                  schemeId: ComponentSettingKey.CircularProgressDesignScheme,
                  fullColor: 'bg',
                },
              },
            ],
          },
        },
        behavior: {
          visibility: true,
        },
      },
    },
  ],
}
